var Model = require("../types/Model.js");

/**
 * This Model is used to determine when to display the logout confirmation modal.
 *  * @type {Model}
 */

module.exports = Model({
	name: "logoutconfirmmodal",
	init: init,
	triggers: triggers,
});

function triggers() {
	return {
		"show": show_logout_modal,
		"hide": hide_logout_modal,
	};
}
function init() {
	this.push(false);
}

function show_logout_modal() {
	this.push(true);
	this.emit("usermetrics:trigger:track", "show logout modal");
}

function hide_logout_modal() {
	this.push(false);
	this.emit("usermetrics:trigger:track", "hide logout modal");
}
